<template>
  <div :style="`height: ${height}px;overflow-y: scroll; ${backgroundStyle}`">
    <div class="w-100 p-3 d-flex align-items-center justify-content-between"
      style="background-color: rgba(250, 250, 250, 0.7);">
      <span>
        <strong>{{ $t("js.backend.ballot_preview.interactive_preview", {}, { locale: initialLocale }) }}</strong>
      </span>
      <div class="d-flex gap-2">
        <select class="btn btn-sm btn-dark dropdown-toggle" @change="setSelectedLocale(($event.target as HTMLSelectElement).value)">
          <option v-for="locale in availableLocales" :key="`${locale}-locale`" :value="locale">
            {{ $t("js.language_name", {}, { locale: locale }) }}
          </option>
        </select>
      </div>
    </div>
    <div class="p-0 m-0">
      <div class="container p-0 px-md-5 pt-sm-3 pt-md-5 pb-5">
        <div class="card border-0 rounded-0 shadow-lg h-100 mb-3">
          <div
            class="card-header no-accent d-flex flex-column flex-sm-row align-items-stretch bg-theme rounded-0 border-bottom align-items-sm-center p-0">
            <div v-if="themeImg" class="bg-light p-3 align-self-stretch d-flex align-items-center">
              <img :src="themeImg" class="me-3" style="max-height: 50px; max-width: 100%">
            </div>
            <div class="d-flex flex-grow-1 align-items-center justify-content-between p-3">
              <h3 class="mb-0">{{ electionTitle[locale as SupportedLocale] }}</h3>
            </div>
          </div>
          <div class="card-body h-100 p-3 p-md-5">
            <template v-if="layout === 'header_with_text'">
              <header v-if="slide.data.title" class="h1 text-center">{{ slide.data.title[locale] }}</header>
              <div v-if="slide.data.description" class="lead" v-html="slide.data.description[locale]"></div>
            </template>
            <template v-else-if="layout === 'header_with_image'">
              <header v-if="slide.data.title" class="h1 text-center">{{ slide.data.title[locale] }}</header>
              <div class="text-center">
                <img :src="slideImage" class="img-fluid">
              </div>
            </template>
            <template v-else-if="layout === 'single_image'">
              <div class="text-center">
                <img :src="slideImage" class="img-fluid">
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType, Locale, LocalString, SupportedLocale, BallotSlide } from "@/types";

export default defineComponent({
  name: "PresentationPreview",
  props: {
    slide: {
      type: Object as PropType<BallotSlide>,
      required: true,
    },
    locale: {
      type: String as PropType<Locale>,
      required: true,
    },
    electionTitle: {
      type: Object as PropType<LocalString>,
      required: true,
    },
    themeImg: {
      type: String,
      default: "",
    },
    backgroundStyle: {
      type: String,
      default: "",
    },
    height: {
      type: Number,
      default: null,
    },
    layout: {
      type: String,
      default: "",
    },
    slideImage: {
      type: String,
      default: "",
    },
    initialLocale: {
      type: String as PropType<Locale>,
      required: true,
    },
    availableLocales: {
      type: Array as PropType<Locale[]>,
      required: true,
    },
  },
  methods: {
    setSelectedLocale(selected: Locale) {
      this.selectedLocale = selected;
      this.$i18n.locale = selected;
    },
  },
  data() {
    return {
      selectedLocale: this.initialLocale,
    }
  },
  created() {
    this.$i18n.locale = this.initialLocale;
  },
});
</script>
